import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { baseFontSize, largePX, mediumPX, mobilePX, smallPX } from '../styles/breakpoints';
export var media = /*#__PURE__*/function (media) {
  media[media["small"] = 0] = "small";
  media[media["medium"] = 1] = "medium";
  media[media["large"] = 2] = "large";
  media[media["none"] = 3] = "none";
  return media;
}({});
export var useBreakpoints = function useBreakpoints(customQuery) {
  var mobileQuery = useMatchMedia("(max-width: ".concat(mobilePX / baseFontSize, "em)"));
  var smallQuery = useMatchMedia("(max-width: ".concat(smallPX / baseFontSize, "em)"));
  var mediumQuery = useMatchMedia("(min-width: ".concat((smallPX + 1) / baseFontSize, "em) and (max-width: ").concat(mediumPX / baseFontSize, "em)"));
  var largeQuery = useMatchMedia("(min-width: ".concat((mediumPX + 1) / baseFontSize, "em) and (max-width: ").concat(largePX / baseFontSize, "em)"));
  var customMatch = useMatchMedia(buildCustomQuery(customQuery));
  var width = media.none;
  if (smallQuery) {
    width = media.small;
  } else if (mediumQuery) {
    width = media.medium;
  } else if (largeQuery) {
    width = media.large;
  }
  var screenSize = {
    onMobile: mobileQuery,
    media: width
  };
  return {
    screenSize: screenSize,
    customMatch: customMatch
  };
};
function buildCustomQuery(customPX) {
  var query = '';
  if ((customPX === null || customPX === void 0 ? void 0 : customPX.minPX) != null) {
    var _customPX$minPX;
    query += "(min-width: ".concat(((_customPX$minPX = customPX.minPX) !== null && _customPX$minPX !== void 0 ? _customPX$minPX : 0) / baseFontSize, "em)");
  }
  if ((customPX === null || customPX === void 0 ? void 0 : customPX.maxPX) != null) {
    if (query) {
      query += ' and ';
    }
    query += "(max-width: ".concat(customPX.maxPX / baseFontSize, "em)");
  }
  return query;
}
export function withBreakpoints(Component) {
  var WithBreakpoints = function WithBreakpoints(props) {
    var context = useBreakpoints();
    return /*#__PURE__*/React.createElement(Component, _extends({}, context, props));
  };
  return WithBreakpoints;
}
var useMatchMedia = function useMatchMedia(mediaQuery) {
  var _React$useState = React.useState(function () {
      return !!mediaQuery && window.matchMedia(mediaQuery).matches;
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    match = _React$useState2[0],
    setMatch = _React$useState2[1];
  React.useEffect(function () {
    if (!mediaQuery) {
      return;
    }
    var queryList = window.matchMedia(mediaQuery);
    var updateMatch = function updateMatch() {
      setMatch(queryList.matches);
    };
    updateMatch();
    queryList.addEventListener('change', updateMatch);
    return function () {
      queryList.removeEventListener('change', updateMatch);
    };
  }, [mediaQuery]);
  return match;
};